module.exports = __webpack_public_path__ + "img/Add-icon.79bfbf78.svg";